import React, { useEffect } from "react";
import Layout from "../components/globalView/Layout";
import { useNavigate } from "react-router-dom";
import "../scss/index.scss";

const AuthPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const lastPage = localStorage.getItem("lastPage");

    navigate(`/${lastPage || "overview"}`); // Use navigate instead of props.history.push
    // Mount-only ON PURPOSE: navigate changes identity on every navigation in
    // RRv6, so [navigate] deps re-ran this after EVERY route change and snapped
    // any link that didn't dispatch changePage back to lastPage (vip-tiers bug).
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <Layout />
    </div>
  );
};

export default AuthPage;
